import { render, staticRenderFns } from "./AppDataExport.vue?vue&type=template&id=991e8884&scoped=true&"
import script from "./AppDataExport.vue?vue&type=script&lang=js&"
export * from "./AppDataExport.vue?vue&type=script&lang=js&"
import style0 from "./AppDataExport.vue?vue&type=style&index=0&id=991e8884&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991e8884",
  null
  
)

export default component.exports